'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/products', {
      template: require('./products.pug'),
      controller: 'ProductsController',
      controllerAs: 'products',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/products/products.routes.ts